/* List-only presentation. Cart policy and variant selection belong to the cart adapter. */
(() => {
  'use strict';
  if (window.FCSCollectionList) return;
  const cards = '.product-list--collection .product-item,.boost-sd__product-list .boost-sd__product-item';
  const listModes = '.product-item--list,.boost-sd__product-item-list-view-layout';
  const actions = '.product-item__action-list,.product-item__action-button,.boost-sd__product-button,.boost-sd__button--quick-view,.boost-sd__button--select-option,.boost-sd__button--add-to-cart,.boost-sd__product-item-list-view-layout-cta-buttons';
  const fitPositions = new WeakMap();
  const salePositions = new WeakMap();
  function createViewAnchor(doc,win,frame) {
    let pending=null,serial=0;
    const cancel=()=>{serial++;if(pending)win.clearTimeout(pending.timeout);pending=null;};
    function capture(event){
      const icon=event.target.closest?.('.boost-sd__view-as-icon');
      if(!icon){cancel();return;}
      cancel();
      const toolbar=icon.closest('.boost-sd__toolbar-container'),value=icon.dataset.value;
      if(!toolbar||!value||icon.classList.contains('boost-sd__view-as-icon--active'))return;
      pending={top:toolbar.getBoundingClientRect().top,value,timeout:win.setTimeout(cancel,1500),queued:false};
    }
    function ready(value){
      const icons=[...doc.querySelectorAll('.boost-sd__view-as-icon--active')];
      const icon=icons.find(node=>node.dataset.value===value),toolbar=icon?.closest('.boost-sd__toolbar-container');
      const card=doc.querySelector('.boost-sd__product-list .boost-sd__product-item');
      if(!toolbar||!card)return null;
      const list=card.matches(listModes)||!!card.closest('.boost-sd__product-list--list-view');
      return list===(value==='list')?toolbar:null;
    }
    function afterRender(){
      if(!pending||pending.queued||!ready(pending.value))return;
      pending.queued=true;const ticket=serial;
      // Let Boost finish its layout and scroll update before restoring the toolbar.
      frame(()=>frame(()=>{
        if(!pending||ticket!==serial)return;
        const toolbar=ready(pending.value);
        if(!toolbar){pending.queued=false;return;}
        const delta=toolbar.getBoundingClientRect().top-pending.top;
        cancel();
        if(Math.abs(delta)>1)win.scrollBy({top:delta,left:0,behavior:'instant'});
      }));
    }
    doc.addEventListener('click',capture,true);
    for(const type of ['wheel','touchstart','pointerdown'])doc.addEventListener(type,cancel,{capture:true,passive:true});
    doc.addEventListener('keydown',event=>{if(['ArrowUp','ArrowDown','PageUp','PageDown','Home','End',' '].includes(event.key))cancel();},true);
    for(const type of ['pagehide','popstate','hashchange'])win.addEventListener(type,cancel);
    return {afterRender,cancel};
  }
  let viewAnchor=null;
  function placeSale(card,active) {
    const previous=salePositions.get(card);
    if(!active){if(previous){if(card.contains(previous.label)&&card.contains(previous.marker))previous.marker.replaceWith(previous.label);previous.label.removeAttribute('data-fcs-list-sale');previous.marker.remove();salePositions.delete(card);}return;}
    const image=card.querySelector('.boost-sd__product-item-list-view-layout-image'),label=card.querySelector('.boost-sd__product-label--sale');
    if(!image||!label)return;
    if(previous&&previous.label!==label){previous.marker.remove();salePositions.delete(card);}
    if(!salePositions.has(card)){const marker=document.createComment('fcs-list-sale-original-position');label.before(marker);salePositions.set(card,{label,marker});}
    label.setAttribute('data-fcs-list-sale','');if(label.parentElement!==image||image.firstElementChild!==label)image.prepend(label);
  }
  const stockRequests = new Map();
  const stockQueue = [];
  let stockRunning = 0;
  function normalizePrice(card) {
    let data;try{data=JSON.parse(card.getAttribute('data-product')||'{}');}catch{return;}
    const min=Number(data.priceMin),max=Number(data.priceMax),compareMin=Number(data.compareAtPriceMin),compareMax=Number(data.compareAtPriceMax);
    if(data.priceMin==null||data.priceMax==null||!Number.isFinite(min)||min<0||min!==max)return;
    const currency=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'});
    const current=card.querySelector('.boost-sd__product-price--sale .boost-sd__format-currency,.boost-sd__product-price--default .boost-sd__format-currency');
    if(current&&current.textContent!==currency.format(min))current.textContent=currency.format(min);
    const content=card.querySelector('.boost-sd__product-price-content');if(!content)return;
    let saving=content.querySelector('[data-fcs-list-saving]');
    if(Number.isFinite(compareMin)&&compareMin===compareMax&&compareMin>min){if(!saving){saving=document.createElement('span');saving.className='fcs-card-price__savings';saving.dataset.fcsListSaving='';content.append(saving);}const label='Save '+currency.format(Math.round((compareMin-min)*100)/100);if(saving.textContent!==label)saving.textContent=label;}else saving?.remove();
  }
  function stockCopy(product) {
    const variants=product?.variants || [],available=variants.filter(variant=>variant.available===true);
    if(!variants.length)return{label:'Check availability',state:'unknown'};
    if(!available.length)return{label:'Out of stock',state:'out'};
    if(available.some(variant=>Number(variant.inventory_quantity)>0 || variant.inventory_management==='shopify' && variant.inventory_policy==='deny'))return{label:available.length<variants.length?'Options in stock':'In stock',state:'in'};
    return{label:'Available to order',state:'order'};
  }
  function loadStock(handle) {
    if(!stockRequests.has(handle))stockRequests.set(handle,new Promise(resolve=>{stockQueue.push({handle,resolve});pumpStock();}));
    return stockRequests.get(handle);
  }
  function pumpStock() {
    if(stockRunning>=2 || !stockQueue.length)return;
    const {handle,resolve}=stockQueue.shift();stockRunning++;
    const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),12000);
    fetch((window.Shopify?.routes?.root||'/')+'products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin',cache:'no-cache',signal:controller.signal})
      .then(response=>{if(!response.ok)throw Error('Stock check unavailable');return response.json();}).then(product=>resolve(stockCopy(product))).catch(()=>resolve({label:'Check availability',state:'unknown'})).finally(()=>{clearTimeout(timeout);stockRunning--;pumpStock();});
    pumpStock();
  }
  const stockObserver=typeof IntersectionObserver==='function'?new IntersectionObserver(entries=>{for(const entry of entries)if(entry.isIntersecting){stockObserver.unobserve(entry.target);hydrateStock(entry.target);}}, {rootMargin:'200px'}):null;
  function hydrateStock(card) {
    const handle=handleOf(card),stock=card.querySelector('[data-fcs-list-stock]');if(!handle||!stock)return;
    loadStock(handle).then(copy=>{if(!stock.isConnected||handleOf(card)!==handle)return;stock.textContent=copy.label;stock.dataset.stockState=copy.state;if(copy.state==='out'){const button=card.querySelector('[data-fcs-list-add]');if(button){button.disabled=true;button.textContent='Out of stock';}card.dataset.fcsListSoldOut='true';}});
  }
  function showStock(card) {
    if(!card.matches('.boost-sd__product-item')||card.querySelector('[data-fcs-list-stock]'))return;
    const price=card.querySelector('.boost-sd__product-price');if(!price)return;
    const stock=document.createElement('span');stock.className='fcs-list-stock';stock.dataset.fcsListStock='';stock.dataset.stockState='unknown';stock.textContent='Checking stock…';price.after(stock);
    if(stockObserver)stockObserver.observe(card);else hydrateStock(card);
  }
  function placeBoostFit(card, active) {
    const previous = fitPositions.get(card);
    if (!active) {
      if (!previous) return;
      // A renderer may replace the badge. Never resurrect a detached old badge.
      if (card.contains(previous.fit)) {
        if (card.contains(previous.marker)) previous.marker.replaceWith(previous.fit);
        else card.append(previous.fit);
      }
      previous.marker.remove();
      fitPositions.delete(card);
      return;
    }
    const group = card.querySelector('.boost-sd__product-item-list-view-layout-info-group');
    const info = group?.querySelector('.boost-sd__product-item-list-view-layout-info');
    const fit = card.querySelector('[data-fcs-fit-status]');
    if (!group || !info || !fit) return;
    if (previous && previous.fit !== fit) {
      previous.marker.remove();
      fitPositions.delete(card);
    }
    if (fit.parentElement === group && info.nextElementSibling === fit) return;
    if (!fitPositions.has(card)) {
      const marker = document.createComment('fcs-list-fit-original-position');
      fit.before(marker);
      fitPositions.set(card, { fit, marker });
    }
    info.after(fit);
  }
  function handleOf(card) {
    const link = card.querySelector('a[href*="/products/"]');
    try { return new URL(link.href, location.origin).pathname.match(/\/products\/([a-z0-9_-]+)/)?.[1] || ''; } catch { return ''; }
  }
  function unavailable(card) {
    try {
      const data = JSON.parse(card.getAttribute('data-product') || '{}');
      if (data.available === false || data.available === 'false') return true;
      if (Array.isArray(data.variants) && data.variants.length && data.variants.every(v => v.available === false)) return true;
    } catch { /* Native availability remains authoritative when app data is absent. */ }
    return !!card.querySelector('.product-item__action-button[disabled],.boost-sd__button--sold-out,.boost-sd__button--add-to-cart[disabled]');
  }
  // Omit only unchecked internal review values from the observed Boost facet.
  // Keep app-owned nodes and selected values intact so clear controls still work.
  const internalFilterValues=new Set(['Needs Price Review','Needs Inventory Review']);
  const hiddenInternalFilters=new Map();
  function internalFilterOption(item){
    if(!item.parentElement?.matches('ul#pf_t_product_features.boost-sd__filter-option-listitem'))return false;
    const button=item.firstElementChild;
    if(!button?.matches('button.boost-sd__filter-option-item-button[role="checkbox"][data-action^="pf_t_product_features."]')||button.getAttribute('aria-checked')!=='false'||button.classList.contains('boost-sd__filter-option-item-button--selected'))return false;
    const value=button.getAttribute('aria-label'),label=button.querySelector('.boost-sd__filter-option-item-label');
    return internalFilterValues.has(value)&&label?.textContent.trim()===value;
  }
  function restoreInternalFilter(item,prior){
    if(item.hidden)item.hidden=prior.hidden;
    if(item.getAttribute('aria-hidden')==='true'){if(prior.aria===null)item.removeAttribute('aria-hidden');else item.setAttribute('aria-hidden',prior.aria);}
    if(item.style.getPropertyValue('display')==='none'&&item.style.getPropertyPriority('display')==='important'){
      if(prior.display)item.style.setProperty('display',prior.display,prior.priority);else item.style.removeProperty('display');
      if(!prior.hadStyle&&!item.getAttribute('style'))item.removeAttribute('style');
    }
    hiddenInternalFilters.delete(item);
  }
  function sanitizeInternalFilterOptions(){
    for(const[item,prior]of hiddenInternalFilters)if(!item.isConnected||!internalFilterOption(item))restoreInternalFilter(item,prior);
    document.querySelectorAll('#pf_t_product_features > li.boost-sd__filter-option-item.boost-sd__filter-option-list-option-item').forEach(item=>{
      if(!internalFilterOption(item))return;
      if(!hiddenInternalFilters.has(item))hiddenInternalFilters.set(item,{hidden:Boolean(item.hidden),aria:item.getAttribute('aria-hidden'),display:item.style.getPropertyValue('display'),priority:item.style.getPropertyPriority('display'),hadStyle:item.hasAttribute('style')});
      item.hidden=true;item.setAttribute('aria-hidden','true');item.style.setProperty('display','none','important');
    });
  }
  let pending = false;
  function decorate() {
    sanitizeInternalFilterOptions();
    labelViewControls();
    pending = false;
    document.querySelectorAll(cards).forEach(card => {
      const active = card.matches(listModes) || !!card.closest('.boost-sd__product-list--list-view');
      const handle = handleOf(card);
      if (!active || !handle) {
        placeBoostFit(card, false);
        placeSale(card,false);
        card.removeAttribute('data-fcs-list-row');
        card.querySelector('[data-fcs-list-add]')?.remove();
        card.querySelector('[data-fcs-list-stock]')?.remove();
        card.querySelector('[data-fcs-list-saving]')?.remove();
        return;
      }
      if(card.dataset.fcsListStockHandle!==handle){card.querySelector('[data-fcs-list-stock]')?.remove();delete card.dataset.fcsListSoldOut;card.dataset.fcsListStockHandle=handle;}
      placeBoostFit(card, true);
      placeSale(card,true);
      normalizePrice(card);
      showStock(card);
      if (!card.hasAttribute('data-fcs-list-row')) card.setAttribute('data-fcs-list-row', '');
      let button = card.querySelector('[data-fcs-list-add]');
      if (!button) {
        button = document.createElement('button');
        button.type = 'button'; button.className = 'fcs-list-add'; button.dataset.fcsListAdd = '';
        card.append(button);
      }
      if (button.dataset.productHandle !== handle) button.dataset.productHandle = handle;
      const soldOut = card.dataset.fcsListSoldOut==='true'||unavailable(card),uncertain=button.dataset.fcsAddUncertain==='true';
      if (button.disabled !== (soldOut||uncertain) && button.getAttribute('aria-busy') !== 'true') button.disabled = soldOut||uncertain;
      const label = uncertain?'Review cart':soldOut ? 'Sold out' : 'Add to cart';
      if (button.getAttribute('aria-busy') !== 'true' && button.textContent !== label) button.textContent = label;
      card.querySelectorAll(actions).forEach(action => {
        if (!action.hasAttribute('data-fcs-list-original-action')) action.setAttribute('data-fcs-list-original-action', '');
      });
    });
    viewAnchor?.afterRender();
  }
  function labelViewControls(){
    document.querySelectorAll('.boost-sd__view-as-icon').forEach(icon=>{
      const label=icon.classList.contains('boost-sd__view-as-icon--list')?'List':'Grid';
      icon.dataset.fcsViewLabel=label;icon.setAttribute('role','button');icon.setAttribute('tabindex','0');icon.setAttribute('aria-label',label+' view');icon.setAttribute('aria-pressed',String(icon.classList.contains('boost-sd__view-as-icon--active')));
    });
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(decorate); } }
  function start() {
    if (!document.body.matches('.fcs-beta-storefront.template-collection')) return;
    document.addEventListener('keydown',event=>{const icon=event.target.closest?.('.boost-sd__view-as-icon');if(icon&&['Enter',' '].includes(event.key)){event.preventDefault();icon.click();}});
    viewAnchor=createViewAnchor(document,window,requestAnimationFrame);
    document.addEventListener('click', event => {
      const button = event.target.closest?.('[data-fcs-list-add]');
      if (!button || button.disabled || !button.closest('[data-fcs-list-row]')) return;
      event.preventDefault();
      button.dispatchEvent(new CustomEvent('fcs:list-add-request', {
        bubbles: true, cancelable: true, detail: { handle: button.dataset.productHandle, button }
      }));
    });
    new MutationObserver(schedule).observe(document.querySelector('main') || document.body, {
      subtree: true, childList: true, characterData: true, attributes: true,
      attributeFilter: ['class', 'data-product', 'disabled', 'href', 'aria-checked']
    });
    schedule();
  }
  window.FCSCollectionList = { refresh: schedule, core: {stockCopy,createViewAnchor} };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
